module.exports = __webpack_public_path__ + "static/media/the-parisian.95c36381.jpg";